module.exports = __webpack_public_path__ + "static/media/carousel-1.c445c07f.jpg";